import { dateFormat } from '@mirai/locale';

import { CALENDAR_FORMAT } from './constants';

export const valueFormat = ([from, to] = []) => [
  from ? dateFormat(from, { format: CALENDAR_FORMAT }) : undefined,
  to ? dateFormat(to, { format: CALENDAR_FORMAT }) : undefined,
];
